<template>
    <div :class="['totem-overlay', { 'cover-sidebar' : shouldCoverSidebar }]" v-on="$listeners" v-bind="$attrs"></div>
</template>

<script>
    export default {
        name: 'totem-overlay',
        props: {
            shouldCoverSidebar: {
                type: Boolean,
                default: false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .totem-overlay {
        @include black('background-color', 0.5);
        position: fixed;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        z-index: 998;

        &.cover-sidebar {
            z-index: 999;
        }
    }
</style>
